import cn from 'classnames';
import styles from 'components/Shared/Select/styles.scss';
import { format } from 'utils';

export interface OptionProps {
  value: number | string;
  label: string;
  disabled?: boolean;
  className?: string;
}

export interface SelectInjectedProps extends OptionProps {
  labelFormat?: string;
  onClick: () => void;
  selected: boolean;
}

export const Option = (props: OptionProps) => {
  const { value, label, disabled, className, selected, onClick, labelFormat } =
    props as SelectInjectedProps;
  return (
    <li
      key={value}
      className={cn(
        {
          [styles.selected]: selected,
          [styles.disabled]: disabled
        },
        className
      )}
      onClick={onClick}
    >
      {labelFormat ? format(labelFormat, label) : label}
    </li>
  );
};
